export default function installStripUnknownParams(router) {
  const cache = new Map();

  function allowedParamsFor(name) {
    if (cache.has(name)) return cache.get(name);
    const record = router.getRoutes().find(r => r.name === name);
    if (!record) return null;
    const allowed = new Set([...record.path.matchAll(/:([A-Za-z_$][\w$]*)/g)].map(m => m[1]));
    cache.set(name, allowed);
    return allowed;
  }

  function clean(to) {
    if (!to || typeof to !== 'object' || !to.name || !to.params) return to;
    const allowed = allowedParamsFor(to.name);
    if (!allowed) return to;
    const params = {};
    for (const [key, value] of Object.entries(to.params)) {
      if (allowed.has(key)) params[key] = value;
    }
    return {...to, params};
  }

  const {push, replace, resolve} = router;
  router.push = (to) => push.call(router, clean(to));
  router.replace = (to) => replace.call(router, clean(to));
  router.resolve = (to, current) => resolve.call(router, clean(to), current);
  router.safePush = (to) => router.push(to).catch(err => err);
}
